import Vue from 'vue';
import Vuex from 'vuex';
import products from '@/assets/json/products.json';
import questions from '@/assets/json/questions.json';

Vue.use(Vuex);

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default new Vuex.Store({
  state: {
    iframeMode: inIframe(),
    products,
    questions,
    finder: {
      currentId: 0,
      history: [], // Revert history contains past IDs
      results: null,
    },
  },
  mutations: {
    setCurrentId(state, payload) {
      state.finder.currentId = payload;
    },

    historyBack(state) {
      if (state.finder.history.length > 0) {
        state.finder.history.pop();

        // Make sure to delete results to let the user go back to the questions
        state.finder.results = null;
      }
    },

    historyAdd(state, payload) {
      state.finder.history.push(payload);
    },

    setResults(state, payload) {
      state.finder.results = payload;
    },

    restartFinder(state) {
      state.finder.currentId = 0;
      state.finder.history = [];
      state.finder.results = null;
    },
  },
  actions: {
    setCurrentId(context, payload) {
      context.commit('setCurrentId', payload);
    },

    historyBack(context) {
      context.commit('historyBack');
    },

    historyAdd(context, payload) {
      context.commit('historyAdd', payload);
    },

    setResults(context, payload) {
      context.commit('setResults', payload);
    },

    restartFinder(context) {
      context.commit('restartFinder');
    },
  },
  modules: {},
});
